import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, deleteApi } from 'services/rotasp/api';
import { PATH_SGU_DOMINIOS_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, ExcluirSufixoRequest } from './types';

// ACTIONS
import { excluirSufixoSuccess, excluirSufixoFailure } from './action';

function* excluirSufixo(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: ExcluirSufixoRequest } =
		request;

	const response: ApiResponse = yield call(
		deleteApi,
		token || '',
		PATH_SGU_DOMINIOS_API,
		`sufixos/${payload.descricao}`,
	);

	if (response.status === 200) {
		yield put(excluirSufixoSuccess(response));
	} else if (response.error) {
		yield put(excluirSufixoFailure());
	}
}

export default all([takeLatest(Types.EXCLUIR_SUFIXO, excluirSufixo)]);
